import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=5d40a77a&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=5d40a77a&prod&scoped=true&lang=css"
import style1 from "./CompanyInfo.vue?vue&type=style&index=1&id=5d40a77a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40a77a",
  null
  
)

export default component.exports